var nav = false;
const navCheck = document.getElementById( 'navcheck' );

function resetNavDropdowns () {
	const openSubmenu = document.querySelectorAll('li.menu-item.visible');
	if ( navCheck && !navCheck.checked ) {
		openSubmenu.forEach(( el ) => {
			el.classList.remove( 'visible' );
		})
	}
}

function disableScroll () {
	// Get the current page scroll position
	scrollTop = document.documentElement.scrollTop;
	scrollLeft = document.documentElement.scrollLeft,

	// if any scroll is attempted,
	// set this to the previous value
	window.onscroll = function () {
		window.scrollTo( scrollLeft, scrollTop );
	};

	nav = true;
}

function enableScroll () {
	window.onscroll = function () { };
	nav = false;
}

window.toggleNav = toggleNav;

function toggleNav () {
	nav ? enableScroll() : disableScroll();
	resetNavDropdowns();
}
